import type { ConfigurationContextValue } from "./ConfigurationContext";
import {
  CONNECTION_PIPELINE_STAGES,
  DEAL_CATEGORIES,
  NOTE_STATUSES,
} from "./crmVocabulary.generated";

export const defaultDarkModeLogo = "./logos/logo_atomic_crm_dark.svg";
export const defaultLightModeLogo = "./logos/logo_atomic_crm_light.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "Atomic CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

// Generated from config/crm-vocabulary.json — do not hand-edit the list;
// change the JSON and run `make vocabulary-gen`.
export const defaultConnectionPipelineStages = CONNECTION_PIPELINE_STAGES.map(
  ({ value, label, order }) => ({ value, label, order }),
);

export const defaultCompanyLifecycleStages = [
  { value: "Lead", label: "Lead" },
  { value: "Prospect", label: "Prospect" },
  { value: "Customer", label: "Customer" },
  { value: "Partner", label: "Partner" },
  { value: "Other", label: "Other" },
];

export const defaultDealStages = [
  { value: "opportunity", label: "Opportunity" },
  { value: "proposal-sent", label: "Proposal Sent" },
  { value: "in-negociation", label: "In Negotiation" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "delayed", label: "Delayed" },
];

export const defaultDealPipelineStatuses = ["won"];

// Deal source attribution per the Relationship Doctrine (generated from
// config/crm-vocabulary.json). There is deliberately no Cold value.
export const defaultDealCategories = DEAL_CATEGORIES.map(
  ({ value, label }) => ({ value, label }),
);

// Generated from config/crm-vocabulary.json (David A. Fields A/B/C scale).
export const defaultNoteStatuses = NOTE_STATUSES.map(
  ({ value, label, color }) => ({ value, label, color: color ?? "#7dbde8" }),
);

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

/**
 * Authentication configuration is a property of the deployment, not of the
 * user's stored preferences: it comes from the build-time environment and
 * falls back to the Yeret Agility Workspace domain when unset.
 */
export const defaultGoogleWorkplaceDomain: string =
  import.meta.env.VITE_GOOGLE_WORKPLACE_DOMAIN || "yeretagility.com";

export const defaultDisableEmailPasswordAuthentication: boolean =
  import.meta.env.VITE_DISABLE_EMAIL_PASSWORD_AUTHENTICATION === "true";

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
  connectionPipelineStages: defaultConnectionPipelineStages,
  companyLifecycleStages: defaultCompanyLifecycleStages,
  googleWorkplaceDomain: defaultGoogleWorkplaceDomain,
  disableEmailPasswordAuthentication: defaultDisableEmailPasswordAuthentication,
};
